var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselArrowPrev(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "24px",
    viewBox: "0 0 29 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop/Home-New-User-Prospect",
    transform: "translate(-157.000000, -1335.000000)",
    fill: "#0071FD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Testimonal-Module",
    transform: "translate(0.000000, 707.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Testimonial-Copy",
    transform: "translate(157.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow",
    transform: "translate(14.500000, 115.000000) rotate(180.000000) translate(-14.500000, -115.000000) translate(0.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5364691,10.8791338 L18.0635484,0.460636385 C17.7645916,0.163239778 17.3661396,0 16.9412814,0 C16.5159516,0 16.1177354,0.163474318 15.8187785,0.460636385 L14.8679166,1.40677039 C14.5691955,1.70369791 14.4046277,2.1003049 14.4046277,2.52318036 C14.4046277,2.94582128 14.5691955,3.35579704 14.8679166,3.65272457 L20.9776704,9.7439606 L1.56669424,9.7439606 C0.691514553,9.7439606 0,10.4255336 0,11.2963803 L0,12.6339614 C0,13.5048081 0.691514553,14.2551012 1.56669424,14.2551012 L21.0469869,14.2551012 L14.8681523,20.3803456 C14.5694312,20.6777422 14.4048635,21.0635603 14.4048635,21.4864358 C14.4048635,21.9088422 14.5694312,22.3002893 14.8681523,22.5974513 L15.8190143,23.5405363 C16.1179712,23.8379329 16.5161873,24 16.9415171,24 C17.3663754,24 17.7648273,23.8358221 18.0637842,23.5384255 L28.5367049,13.1201626 C28.8363691,12.8218278 29.0011726,12.4235791 29,12.0002345 C29.0009368,11.5754828 28.8363691,11.1769995 28.5364691,10.8791338 Z",
    id: "Path"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrowPrev);
export default __webpack_public_path__ + "static/media/carousel-arrow-prev.7a45007aa391455a876b7c372cc610e5.svg";
export { ForwardRef as ReactComponent };